<template>
  <el-button
    type="text"
    @click="clickButton(row.id)"
  >
    {{ `${row.fio}` }}
  </el-button>
</template>

<script lang="ts">
import {
  defineComponent, PropType,
} from 'vue';

export default defineComponent({
  name: 'ResidentLink',
  props: {
    row: {
      type: Object as PropType<any>,
      required: true,
    },
    column: {
      type: Object as PropType<any>,
      required: true,
    },
  },
  setup () {
    // @ts-ignore
    const clickButton = (residentId) => {
      window.open(`/residents/${residentId}`, '_blank');
    };

    return {
      clickButton,
    };
  },
});
</script>
